export const getCookie = (name) => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) {
    return decodeURIComponent(parts.pop().split(";").shift());
  }
  return null;
};

export const setCookie = (name, value, days = 1) => {
  const expires = new Date(Date.now() + days * 864e5).toUTCString();
  const secure = window.location.protocol === "https:" ? "; secure" : "";
  document.cookie = `${name}=${encodeURIComponent(
    value
  )}; expires=${expires}; path=/; domain=.mybiocalculus.com; samesite=Lax${secure}`;
};

export const deleteCookie = (name) => {
  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=.mybiocalculus.com`;
};

let _lastHeartbeatWriteAt = 0;
export const writeHeartbeat = () => {
  const now = Date.now();
  if (now - _lastHeartbeatWriteAt < 5000) return;
  _lastHeartbeatWriteAt = now;
  setCookie("lastActivityAt", String(now));
};

export const readHeartbeat = () => {
  const v = getCookie("lastActivityAt");
  return v ? parseInt(v, 10) : 0;
};

export const writeBreakState = ({ breakTime, isOnBreak, breakStartTime }) => {
  if (breakTime !== undefined) setCookie("breakTime", String(breakTime));
  if (isOnBreak !== undefined) setCookie("isOnBreak", isOnBreak ? "true" : "false");
  if (breakStartTime !== undefined && breakStartTime !== null) {
    setCookie("breakStartTime", String(breakStartTime));
  } else if (breakStartTime === null) {
    deleteCookie("breakStartTime");
  }
};

export const readBreakState = () => {
  const bt = parseFloat(getCookie("breakTime"));
  const bs = getCookie("breakStartTime");
  return {
    breakTime: Number.isFinite(bt) ? bt : 0,
    isOnBreak: getCookie("isOnBreak") === "true",
    breakStartTime: bs ? parseInt(bs, 10) : null,
  };
};
